/** Shared chat chrome (seller portal): neutral surfaces that follow the light/dark palette. */

export const CHAT_HEADER_CLASS =
  "flex shrink-0 items-center gap-3 border-b border-surface-200 bg-surface-0 px-4 py-3";

export const CHAT_WALLPAPER_CLASS =
  "flex-1 overflow-y-auto overscroll-contain bg-surface-50 bg-[radial-gradient(var(--color-surface-200)_1px,transparent_1px)] [background-size:18px_18px] px-2 py-4 sm:px-4";

export const CHAT_SHELL_MIN_HEIGHT =
  "min-h-[min(70dvh,32rem)] lg:min-h-[min(75dvh,36rem)]";

/** Fit-content bubbles may grow up to this width before wrapping. */
export const CHAT_BUBBLE_MAX_WIDTH_CLASS = "max-w-[min(85%,40rem)]";

export const CHAT_INPUT_BAR_CLASS =
  "flex items-end gap-2 border-t border-surface-200 bg-surface-0 px-3 py-2.5";

export const CHAT_CLOSED_FOOTER_CLASS =
  "shrink-0 border-t border-surface-200 bg-surface-0 px-4 py-3.5 text-center";

/** Auto-growing message textarea inside `CHAT_INPUT_BAR_CLASS`. */
export const CHAT_TEXTAREA_CLASS =
  "max-h-[7.5rem] min-h-10 flex-1 resize-none rounded-xl border border-surface-200 bg-surface-0 px-3.5 py-2 text-base leading-relaxed text-surface-900 shadow-xs outline-none sm:text-sm transition-[border-color,box-shadow] placeholder:text-surface-400 focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 disabled:opacity-60";

/** Round send button paired with `CHAT_TEXTAREA_CLASS`. */
export const CHAT_SEND_BUTTON_CLASS =
  "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-white shadow-xs transition-[background-color,transform] active:scale-95 disabled:cursor-not-allowed disabled:bg-surface-200 disabled:text-surface-400 disabled:shadow-none";

/** Icon-only secondary control in the input bar (e.g. attach). */
export const CHAT_ICON_BUTTON_CLASS =
  "flex h-10 w-10 shrink-0 items-center justify-center rounded-xl text-surface-500 transition-colors hover:bg-surface-100 hover:text-surface-900 disabled:cursor-not-allowed disabled:opacity-50";
